import ApiService from '@/services/core/api.service'

const EmployeeService = {
  async get (query) {
    return ApiService.get(`user/employees?${query}`)
  },

  async post (payload) {
    return ApiService.post('user/employees', payload)
  },

  async put (payload) {
    return ApiService.put(`user/employees/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`user/employees/${payload.id}`)
  }
}

export default EmployeeService
